export default "__VITE_PUBLIC_ASSET__2b914f46__"